import React from "react";
import { Colors } from "../../config";
import styled from "styled-components";

const OnBoardingHeader = ({ header }) => {
  return <StyledHeader>{header}</StyledHeader>;
};

const StyledHeader = styled.div`
  font-weight: 800;
  font-size: 2rem;
  color: ${Colors.brandOne};
  margin-bottom: 1.438rem;
  text-transform: uppercase;
  @media only screen and (max-width: 478px) {
    font-size: 1.6rem;
  }
`;

export default OnBoardingHeader;
